export const APP_VERSION = 2;
export const APP_VERSION_FOR_SHOW = "2.2.0";
export const APP_UPDATE_DATE = "2026-09-09 20:00";
